import { Component, Input } from '@angular/core';
import { FormMessage } from './form-message.model';
import { NgClass } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'fnsr-form-message',
  standalone: true,
  imports: [NgClass, IconComponent],
  templateUrl: './form-message.component.html'
})
export class FormMessageComponent {
  @Input() formMessage?: FormMessage;
}
